/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import { type ForwardedRef, type ReactElement, type ReactNode, createContext, forwardRef, useEffect, useMemo } from 'react';
import { Collection, type ContextValue, type SlotProps, useContextProps } from 'react-aria-components';

interface SeriesProps<T> extends SlotProps {
  colorScale: {
    domain: string[];
    range: string[];
  };
  data?: T[][];
  registerSeries?: (
    series: {
      label?: string;
      color: string;
    }[],
  ) => void;
  children?: (props: { id: string; label: string; color: string; data: { x: number; y: number }[] }) => ReactNode;
}

const SeriesContext = createContext<ContextValue<SeriesProps<object>, SVGGElement>>({});

const Series = forwardRef((props: SeriesProps<object>, ref: ForwardedRef<SVGGElement>) => {
  [props, ref] = useContextProps(props, ref, SeriesContext);

  const { colorScale, data = [], registerSeries, children, ...coreProps } = props;

  const collectionItems = useMemo(
    () =>
      data.map((item, index) => ({
        id: colorScale.domain[index] ?? `series-${index}`,
        label: colorScale.domain[index],
        color: colorScale.range[index],
        data: item as { x: number; y: number }[],
      })),
    [colorScale.domain, colorScale.range, data],
  );

  useEffect(() => {
    if (!registerSeries) {
      return;
    }

    registerSeries(collectionItems);

    return () => registerSeries([]);
  }, [collectionItems, colorScale.domain, colorScale.range, registerSeries]);

  if (!children) {
    return null;
  }

  return (
    <g ref={ref} {...coreProps}>
      <Collection items={collectionItems}>{children}</Collection>
    </g>
  );
}) as <T>(p: SeriesProps<T> & { ref?: ForwardedRef<SVGGElement> }) => ReactElement;

export { Series, SeriesContext, type SeriesProps };
